import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';
import type Progress from 'pages/open-course/common/models/progress';

import Evaluation from 'bundles/phoenix/models/evaluation';

/**
 * Methods for reading the state in peer review's ItemProgress objects.
 */
class PeerState {
  itemMetadata: ItemMetadata;

  // @ts-expect-error ts-migrate(4031) FIXME: Public property 'itemProgress' of exported class h... Remove this comment to see the full error message
  itemProgress: Progress;

  // @ts-expect-error ts-migrate(4063) FIXME: Parameter 'itemProgress' of constructor from expor... Remove this comment to see the full error message
  constructor(itemMetadata: ItemMetadata, itemProgress: Progress) {
    this.itemMetadata = itemMetadata;
    this.itemProgress = itemProgress;
  }

  getEvaluation() {
    return new Evaluation(this.itemProgress.getDefinition('evaluation'));
  }

  isEvaluated() {
    return this.getEvaluation().isDefined();
  }

  isFailed() {
    return this.isEvaluated() && this.getEvaluation().isFailed();
  }

  isPassed() {
    return this.isEvaluated() && this.getEvaluation().isPassed();
  }

  isReviewingComplete() {
    return this.reviewCount() >= this.requiredReviewCount();
  }

  isSubmitted() {
    return !!this.itemProgress.getDefinition('submitted');
  }

  remainingReviewCount() {
    return Math.max(this.requiredReviewCount() - this.reviewCount(), 0);
  }

  requiredReviewCount() {
    return (
      this.itemProgress.getDefinition('requiredReviewCount') ||
      this.itemMetadata.getDefinition('requiredReviewCount') ||
      0
    );
  }

  reviewCount() {
    return this.itemProgress.getDefinition('reviewCount') || 0;
  }
}

export default PeerState;
